import isEmpty from './isEmpty.js'
//-------------------------------------------------------------------------------------
// collect unique characteristic skill adjs for given characteristic names
//-------------------------------------------------------------------------------------
export default function collectCharacteristicSkillAdjsUnique({
  characteristicSkillAdjs = [],
  skills = [],
  characteristicNames = [],
}) {
  console.log('-------------------------------')
  console.log('IN collectCharacteristicSkillAdjsUnique')
  console.log('characteristicNames = ', characteristicNames)
  //------------------------------
  //check got characteristicNames
  //------------------------------
  const names = Array.isArray(characteristicNames)
    ? characteristicNames
    : characteristicNames
      ? [characteristicNames]
      : []
  //----------------------------------------------------------------------------------
  // normalise characteristicNames to set of lowercase strings (should already be lc)
  //----------------------------------------------------------------------------------
  const nameSet = new Set(names.filter(Boolean).map((n) => String(n).toLowerCase()))
  //----------------------------------------
  // declare map to hold unique adj entries
  //----------------------------------------
  const map = new Map() // key => { characteristic_name, adj_value, adj_reason }
  const sourceAdjs = Array.isArray(characteristicSkillAdjs)
    ? characteristicSkillAdjs
    : Array.isArray(skills)
      ? skills.flatMap((skill) =>
          Array.isArray(skill?.characteristic_skill_adjs) ? skill.characteristic_skill_adjs : [],
        )
      : []

  //=========================================================================
  // MAIN ADJUSTMENTS LOOP
  //=========================================================================
  for (const adj of sourceAdjs) {
    //--------------------------
    // skip invalid adj entries
    //--------------------------
    if (!adj) continue
    //-------------------------------------------------------------------
    // normalise/trim characteristic_name for matching (belt and braces)
    //-------------------------------------------------------------------
    const cName = String(adj.characteristic_name ?? adj.name ?? '')
      .toLowerCase()
      .trim()
    //------------------------------------------------------------
    // match characteristic_name (if nameSet empty => accept all)
    //------------------------------------------------------------
    if (nameSet.size > 0 && !nameSet.has(cName)) continue
    //--------------------------------------------------------------------
    // build unique key from characteristic_name + adj_value + adj_reason
    //--------------------------------------------------------------------
    const value = !isEmpty(adj.adj_value) ? adj.adj_value : (adj.value ?? 0)
    const reason = (adj.adj_reason ?? adj.reason ?? '').toString().trim()
    const key = `${cName}|${value}|${reason}`
    //-----------------------
    // add to map if new key
    //-----------------------
    if (!map.has(key)) {
      map.set(key, {
        adj_armour: adj.adj_armour,
        adj_value: value,
        adj_reason: reason,
        character_item:
          typeof adj.character_item === 'number' || typeof adj.character_item === 'string'
            ? adj.character_item
            : (adj.character_item?.id ?? null),
        characteristic_name: cName,
        id: adj.id,
        name: cName,
        rune_name: adj.rune_name,
      })
    }
  }
  //-----------------------------------------
  // return unique characteristic skill adjs
  //-----------------------------------------
  return Array.from(map.values())
}
